module.exports = __webpack_public_path__ + "static/17-de00ef379018d4361e124dc0fb122bad.jpg";